<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Add Condition</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Condition Category</label>
                    <select class="mvd_form-control" formControlName="medicalAlertCategoryId">
                        <option value=""></option>
                        <option *ngFor="let t of medicalAlertCategoryTypes" [value]="t.id">{{ t.customerIndividualMedicalCategoryTypeDisplayValue }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Condition Type</label>
                    <select class="mvd_form-control" formControlName="medicalAlertTypeId">
                        <option value=""></option>
                        <option *ngFor="let t of medicalConditionTypeOptions" [value]="t.id">{{ t.customerIndividualMedicalAlertTypeDisplayValue }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group" *ngIf="true == form.get('occurrenceDate').enabled">
                    <label>Occurrence Date</label>
                    <max-calendar [showIcon]="true" formControlName="occurrenceDate"></max-calendar>
                </div>
                <div class="col-sm-3 mvd_form-group" *ngIf="true == form.get('lastEpisodeDate').enabled">
                    <label>Last Episode Date</label>
                    <max-calendar [showIcon]="true" formControlName="lastEpisodeDate"></max-calendar>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>&nbsp;</label>
                    <label class="mvd_label--inline">
                        <input type="checkbox" formControlName="isMvdMonitoring">
                        MVD Monitoring
                    </label>
                </div>
                <div class="col-sm-3 mvd_form-group" *ngIf="true == form.get('isMvdMonitoring').value">
                    <label>Review Period Type</label>
                    <select class="mvd_form-control" formControlName="reviewDurationTypeId">
                        <option value=""></option>
                        <option *ngFor="let t of durationTypes" [value]="t.id">{{ t.displayValue }}</option>
                    </select>
                </div>
                <div class="col-sm-2 mvd_form-group" *ngIf="true == form.get('isMvdMonitoring').value">
                    <label>Period Amount</label>
                    <input class="mvd_form-control" autocomplete="off" placeholder="#" type="number" min="1" formControlName="reviewDurationValue" />
                </div>
                <div class="col-sm-3 mvd_form-group" *ngIf="true == form.get('isAdaptiveEquipment').enabled">
                    <label>Adaptive Equipment</label>
                    <select class="mvd_form-control" formControlName="isAdaptiveEquipment">
                        <option value=""></option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                    </select>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button *ngIf="null != data.customerMedicalConditionId" class="btn--accent" type="button" (click)="delete()">Delete</button>
        <mvm-spinner-btn [isDisabled]="false == form.valid"
                         [isLoading]="showButtonLoading"
                         btnText="Save"
                         (clicked)="saveMedicalConditions()">
        </mvm-spinner-btn>
    </div>
</div>